import * as React from "react";

export const CpFormSpace: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [height, setHeight] = React.useState(0);

  React.useEffect(() => {
    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, []);

  function updateHeight() {
    try {
      const sectionEl = document.querySelector(`#page main section`);
      const tagsEl = document.querySelector(`.cpln-form-section[data-section-id="tags"]`);
      const _sectionHeight = sectionEl?.clientHeight || 0;
      const _tagsHeight = tagsEl?.clientHeight || 0;
      setHeight(_sectionHeight - _tagsHeight);
    } catch (e) {}
  }

  return <div style={{ width: "100%", minHeight: height }} />;
};
